import * as React from 'react';
import { sortPartialDate, isPartialDate } from 'neuro-utils';
import TileContentMaker from 'Components/DashboardTile/TileContentMaker';
import { fm } from 'Components/FormatMessage';
import { getSessionType, headerText } from 'Utility/ninmtUtil';
import { DescriptionText } from 'Components/DashboardTile/TileContentMaker/components/common/commonComponents';
import { FormattedMessage } from 'react-intl';
import { formatPartialDate } from 'Utility/date';
import { filterByDocumentType } from 'Utility/documentHandling';

const RTMSData = ({ document }: { document: IDocumentWithTypeV2<'rtms'> }): React.JSX.Element => {
  const { sessions: _sessions, unusedSessions: _unusedSessions } = document;
  const [sessions, unusedSessions] = [_sessions ?? [], _unusedSessions ?? []];

  const allEvents = [...sessions, ...unusedSessions];

  const sessionCount = Array.isArray(document.sessions) ? document.sessions.length : '-';

  return (
    <React.Fragment>
      <TileContentMaker
        type="bigHeaderInfo"
        bigHeaderText={
          document.type
            ? fm(`rtms.opts.${document.type}`)
            : !document.hasEnded
              ? fm('rtms.rtmsOngoing')
              : fm('rtms.rtmsHasEnded')
        }
        bigHeaderValue={headerText(document)}
        data={
          document.sessions && Array.isArray(sessions) && document.hasEnded
            ? [
                {
                  title: fm('rtms.sessionsAndProtocols'),
                  value: <div style={{ whiteSpace: 'pre-line' }}>{sessionCount}</div>,
                  key: 'sessions',
                },
              ]
            : []
        }
      />
      {!document.hasEnded && (
        <TileContentMaker
          type="specificList"
          itemsCanFitAmount={5}
          data={allEvents.map(e => {
            const sessionType = getSessionType(e, sessions, unusedSessions);
            return {
              date: isPartialDate(e.date) ? formatPartialDate(e.date) : '',
              title: sessionType ? fm(`rtms.${sessionType}`) : fm('rtms.session'),
              value: null,
              key: e.id,
            };
          })}
        />
      )}
    </React.Fragment>
  );
};

const RTMSDash = ({ documents }: IOwnProps): React.JSX.Element | undefined => {
  const rtmsArr = filterByDocumentType(documents, 'rtms')
    .sort((n1, n2) => n1._cdate - n2._cdate)
    .sort((n1, n2) => sortPartialDate(n2.date, n1.date));

  const sortedNinmtTreatmentPeriod = filterByDocumentType(documents, 'ninmtTreatmentPeriod')
    .sort((n1, n2) => n1._cdate - n2._cdate)
    .sort((n1, n2) => sortPartialDate(n2.date, n1.date));

  const latestRTMS = rtmsArr.find(d => !d.hasEnded) ?? (rtmsArr.length > 0 ? rtmsArr[0] : undefined);

  return (
    <React.Fragment>
      {latestRTMS ? (
        sortPartialDate(sortedNinmtTreatmentPeriod[0]?.date, latestRTMS.date) === 1 ? (
          <DescriptionText>
            <FormattedMessage id="rtms.noActiveTreatmentPeriod" />
          </DescriptionText>
        ) : (
          <RTMSData document={latestRTMS} />
        )
      ) : (
        <></>
      )}
    </React.Fragment>
  );
};

interface IOwnProps {
  documents: IDocumentWithTypeV2<
    'rtms' | 'doctorsOrders' | 'ninmtTreatmentPeriod' | 'contraIndicationsToTreatment' | 'symptomsAndLocations'
  >[];
}

export default RTMSDash;
